import { RX0007 } from "../rxTypeCode";

export const SET_SOURCEOFFUND = "SET_SOURCEOFFUND" + RX0007;
export const GET_ALLOWED_SOURCEOFFUNDS_REQUEST = "GET_ALLOWED_SOURCEOFFUNDS_REQUEST" + RX0007;
export const GET_ALLOWED_SOURCEOFFUNDS_SUCCESS = "GET_ALLOWED_SOURCEOFFUNDS_SUCCESS" + RX0007;
export const GET_ALLOWED_SOURCEOFFUNDS_FAILURE = "GET_ALLOWED_SOURCEOFFUNDS_FAILURE" + RX0007;
export const CLEANUP = "CLEANUP" + RX0007;